import Text from "shared/components/data-display/text/Text";
import Link from "shared/components/navigation/links/Link";
import styled, { css } from "styled-components/macro";

export const DataItemCard = styled.div`
    display: block;
    width: 12rem;
    cursor: default;
`;

export const StyledLoaderWrapper = styled.div`
    padding-top: 7px;
    padding-left: 7px;
`;

export const StyledDescriptionText = styled(Text)`
    ${(props) =>
        props.isNextLine &&
        css`
            white-space: pre-line;
        `}
`;

export const StyledButton = styled.button`
    width: 16px;
    height: 16px;
    border: none;
    background: transparent;
`;

export const StyledLink = styled(Link)`
    &:hover {
        text-decoration: none;
    }
`;
